module.exports = __webpack_public_path__ + "static/img/向左.1203f41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/向左.svg
// module id = 6lNc
// module chunks = 0